var womensPants = {
  category: "Women's",
  product: "Pants",
  sections: [{
      section: {
        title: "Size Chart",
        type: "table",
        header: [
          "Pant",
          "Size",
          "Your Natural Waist",
          "Your Hips",
          "Your Thigh"
        ],
        rows: [
          ["XS",  "0", "25", "35", "20"],
          ["XS",  "2", "26", "36", "20.75"],
          ["S",  "4", "27", "37", "21.5"],
          ["S",  "6", "28", "38", "22.25"],
          ["M",  "8", "29", "39", "23"],
          ["M",  "10", "30", "40", "23.75"],
          ["L",  "12", "31.5", "41.5", "24.75"],
          ["L",  "14", "33", "43", "25.75"],
          ["XL",  "16", "34.5", "44.5", "26.75"]
        ]
      }
    },
    {
      section: {
        title: "Fit Guidance",
        type: "twoCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Womens_Pants_-_Standard.png?14335",
            title: "Standard:",
            body: "A comfortable modern fit, relaxed throughout. Sits at the natural waist and has a slightly tapered leg."
          }],
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Womens_Pants_-_Petite.png?14335",
            title: "Petite:",
            body: "A shorter rise and length than our Standard Fit to accommodate heights of 5’3” (160 cm) or under."
          }]
        ]
      }
    },
    {
      section: {
        title: 'How to Measure',
        type: "singleCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Womens_-_How_To_Measure.png?14316"
          }],
          [{
            title: "Bust: ",
            body: "Wrap the measuring tape around your chest, under your arm, at the fullest part of the bust, keeping the tape slightly loose."
          }],
          [{
            title: "Arm (Spine to Wrist): ",
            body: "The arm measurement used for sleeve length is measured from the center back of your neck to your wrist. Hold your arm out to the side with your elbow slightly bent, and measure from the back center of your neck (spine) down the outside of your arm to your wrist bone."
          }],
          [{
            title: "Natural Waist: ",
            body: "Bend to the side to find the natural crease of your waist. Stand normally and wrap the measuring tape at this point, keeping the tape slightly loose."
          }],
          [{
            title: "Hips: ",
            body: "With your feet together, wrap the measuring tape around the fullest part of your hips/seat, approximately 8\" (20.3 cm) below your natural waist, keeping the tape slightly loose."
          }],
          [{
            title: "Thigh: ",
            body: "Wrap the measuring tape around the fullest part of your thigh, approximately 1\" (2.5 cm) below the crotch, keeping the tape slightly loose."
          }]
        ]
      }
    }
  ]
};